import {
  Heading as Title,
  Paragraph as Description,
} from '@tmov/design-system';
import PropTypes from 'prop-types';
import React from 'react';

import StatusSelect from './StatusSelect';
import { Container, Lote, Status, TextContainer, Viagem } from './styles';
import { TipoLote } from './TipoLote';
import ViagemInputs from './ViagemInputs';

export function Filtros({ FiltrosData }) {
  const { setField, transportadoras } = FiltrosData;

  const titleProps = {
    variant: 'h4',
    style: {
      color: '#2D3A40',
      fontSize: '16px',
      fontWeight: 600,
    },
  };

  const descriptionProps = {
    variant: 'p1',
    style: {
      color: '#6D787D',
      fontSize: '14px',
    },
  };

  return (
    <Container>
      <Status>
        <TextContainer>
          <Title {...titleProps}>Status</Title>
          <Description {...descriptionProps}>
            Selecione os status que deseja visualizar
          </Description>
        </TextContainer>
        <StatusSelect dispatchField={setField} />
      </Status>

      <Viagem>
        <TextContainer>
          <Title {...titleProps}>Viagem</Title>
          <Description {...descriptionProps}>
            Busque uma viagem específica por motorista ou placa do cavalo
          </Description>
        </TextContainer>
        <ViagemInputs handleText={setField} />
      </Viagem>

      <Lote>
        <TextContainer>
          <Title {...titleProps}>Lote</Title>
          <Description {...descriptionProps}>
            Filtre as viagens por tipo de lote ou uma transportadora específica
          </Description>
        </TextContainer>
        <TipoLote
          dispatchTransportadorasETipoLote={setField}
          transportadoras={transportadoras}
        />
      </Lote>
    </Container>
  );
}

Filtros.propTypes = {
  FiltrosData: PropTypes.shape({
    setField: PropTypes.func.isRequired,
    transportadoras: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }),
};

Filtros.defaultProps = {
  FiltrosData: {},
};
